var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { styled } from '@material-ui/core/styles';
import React, { lazy, Suspense, useContext } from 'react';
import { Grid } from '@material-ui/core';
import { useReactiveVar } from '@apollo/client';
import { currentUserVar } from '../../cache';
import { context as HistoryContext } from '../context/history';
import { context as ConfigContext } from '../context/config';
import { flexibleLayoutContainer } from '../styleUtility/flexibleLayout';
import theme from '../theme';
var SignInForm = lazy(function () { return import('../components/compound/SignInForm'); });
var SignedOutScreen = function (_a) {
    var className = _a.className;
    var history = useContext(HistoryContext);
    var config = useContext(ConfigContext);
    var kaizenIdUrl = "" + config.ID_WEB_URL;
    var kaizenIdWithRedirectUrl = config.ID_WEB_URL + "?done=" + window.location.href;
    if (window.location.href.match(/\/sign_up/)) {
        history.replace('/');
    }
    var currentUser = useReactiveVar(currentUserVar);
    return !currentUser ? (React.createElement(Root, { className: className },
        React.createElement(Container, { container: true },
            React.createElement(VideoContainer, { item: true, lg: 5 },
                React.createElement(Video, { src: "/assets/sign_in_background.mp4", autoPlay: true, loop: true, playsInline: true })),
            React.createElement(FormContainer, { item: true, lg: 7, xs: 12 },
                React.createElement(Suspense, { fallback: React.createElement("div", null) },
                    React.createElement(SignInForm, { kaizenIdUrl: kaizenIdUrl, kaizenIdWithRedirectUrl: kaizenIdWithRedirectUrl })))))) : null;
};
var Root = styled('div')({
    position: 'relative',
});
var Container = styled(Grid)({
    height: '100%',
});
var VideoContainer = styled(Grid)((_a = {},
    _a[theme.breakpoints.down('md')] = {
        display: 'none',
    },
    _a));
var FormContainer = styled(Grid)(__assign(__assign({}, flexibleLayoutContainer({})), { height: '100%' }));
var Video = styled('video')({
    width: '100%',
    height: '100%',
    objectFit: 'cover',
});
export default SignedOutScreen;
